// Màu + kiểu tooltip biểu đồ theo sáng/tối, dùng chung cho mọi biểu đồ của trang Xu.
import { getChartTheme } from "../../../theme/chart-theme";
import { useThemeMode } from "../../../theme/theme-provider";
import { fmtVnDate } from "./xu-format-helpers";

export function useXuChart() {
    const { isDark } = useThemeMode();
    const chart = getChartTheme(isDark);
    return {
        chart,
        tooltip: { contentStyle: { background: chart.tooltipBg, borderColor: chart.tooltipBorder, color: chart.tooltipText } },
    };
}

/** 'YYYY-MM-DD' → 'dd/MM' cho nhãn trục. */
export const shortDate = (d) => fmtVnDate(d).slice(0, 5);
